<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>{{ $t('Add.Button.Button') }} Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="buttonText">{{ $t('Add.Button.ButtonText') }}</label>
      <textarea
        id="buttonText"
        name="buttonText"
        rows="2"
        cols="50"
        v-model="sharedData.data.props.text"
      >
      </textarea>
    </div>
    <div class="divider">
      <label class="contentLabel" for="buttonUrl">{{ $t('Add.Button.ButtonUrl') }}</label>
      <input type="text" id="buttonUrl" v-model="sharedData.data.props.url" />
    </div>
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
      </div>
    </div>
    <!-- Reiter: Style -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('style')" class="accordion-content">
    <FontSizeProp :sharedData="sharedData" />
    <FontFamilyProp :sharedData="sharedData" />
    <div class="divider">
      <label class="contentLabel" for="textColor">{{ $t('Add.Button.TextColor') }}</label>
      <div class="color-container">
        <input type="color" id="textColor" name="textC" v-model="textColor" />
        <span v-if="textColor" class="material-symbols-outlined reset-color" @click="resetColor">refresh</span>
        <div v-else class="add-color-overlay">+</div>
      </div>
    </div>
    <BackgroundColorProp :sharedData="sharedData" />
    </div>
    </div>
    <!--Button Style-->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('buttonStyle')">
        <span>{{ $t('Add.General.ButtonStyle') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('buttonStyle') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('buttonStyle')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="buttonColor">{{ $t('Add.Button.ButtonColor') }}</label>
      <div class="color-container">
        <input type="color" id="buttonColor" name="buttonColor" v-model="buttonColor" />
        <span v-if="buttonColor" class="material-symbols-outlined reset-color" @click="resetButtonColor">refresh</span>
        <div v-else class="add-color-overlay">+</div>
      </div>
    </div>
    <div class="divider">
      <p>{{ $t('Add.Button.Size') }}</p>
      <div class="input-container">
        <label class="first">
          <input type="radio" class="radios" name="size" value="x-small" v-model="size" />
          <span class="radioSelect firstSelect size">XS</span>
        </label>
        <label>
          <input type="radio" class="radios" name="size" value="small" v-model="size" />
          <span class="radioSelect size">S</span>
        </label>
        <label>
          <input type="radio" class="radios" name="size" value="medium" v-model="size" />
          <span class="radioSelect size">M</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="size" value="large" v-model="size" />
          <span class="radioSelect lastSelect size">L</span>
        </label>
      </div>
    </div>
    <div class="divider">
      <p>{{ $t('Add.Button.Shape') }}</p>
      <div class="input-container">
        <label>
          <input type="radio" class="radios" name="shape" value="rectangle" v-model="shape" />
          <span class="radioSelect firstSelect">Rectangle</span>
        </label>
        <label>
          <input type="radio" class="radios" name="shape" value="pill" v-model="shape" />
          <span class="radioSelect">Pill</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="shape" value="rounded" v-model="shape" />
          <span class="radioSelect lastSelect">Rounded</span>
        </label>
      </div>
    </div>
    <div class="divider">
      <p>{{ $t('Add.Button.FontWeight') }}</p>
      <div class="input-container">
        <label>
          <input type="radio" class="radios" name="fontWeight" value="normal" v-model="fontWeight" />
          <span class="radioSelect firstSelect">Regular</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="fontWeight" value="bold" v-model="fontWeight" />
          <span class="radioSelect lastSelect">Bold</span>
        </label>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
    </div>
    <div v-show="isSectionActive('positioning')" class="accordion-content">
    <AlignmentProp :sharedData="sharedData" />
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import FontSizeProp from './AddProps/FontSizeProp.vue';
import FontFamilyProp from './AddProps/FontFamilyProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';

export default {
  name: 'AddButton',
  components: {
    NameProp,
    ClassNamesProp,
    PaddingProp,
    AlignmentProp,
    BackgroundColorProp,
    FontSizeProp,
    FontFamilyProp,
    CopyBlock,
  },  
  props: ['sharedData'],
  data(){
    return {
      //activeSections: ['main'],
      isUniqueName: true, // überwache, ob der Name eindeutig ist
    }
  },
  computed: {
    ...mapState(['emailData']), 
    text: {
      get() {
        return this.sharedData?.data?.props?.text || '';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.text = value;
      },
    },
    url: {
      get() {
        return this.sharedData?.data?.props?.url || '';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.url = value;
      },
    },
    buttonColor: {
      get() {
        return this.sharedData?.data?.props?.buttonBackgroundColor || '#999999';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.buttonBackgroundColor = value;
      },
    },
    textColor: {
      get() {
        return this.sharedData?.data?.props?.buttonTextColor || '#FFFFFF';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.buttonTextColor = value;
      },
    },
    size: {
      get() {
        return this.sharedData?.data?.props?.size || 'medium';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.size = value;
      },
    },
    shape: {
      get() {
        return this.sharedData?.data?.props?.buttonStyle || 'rectangle';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.buttonStyle = value;
      },
    },
    fontWeight: {
      get() {
        return this.sharedData?.data?.style?.fontWeight || 'bold';
      },
      set(value) {
        if (!this.sharedData.data.style) this.sharedData.data.style = {};
        this.sharedData.data.style.fontWeight = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
    resetColor() {
      this.sharedData.data.props.buttonTextColor = null;
    },
    resetButtonColor() {
      this.sharedData.data.props.buttonBackgroundColor = null;
    },
    
  },
};
</script>

 <style scoped>
 @import '../../styles/addComponents.css';
 </style>